import { Injectable } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { PermissionTypeDto, PosMarketplaceUnlockDto } from "clearline-api";
import { UserPermissionService } from "clearline-common";
import { TooltipManagerService } from "./tooltip-manager.service";

@Injectable({
  providedIn: "root"
})
export class TooltipRegistrationService {
  constructor(
    private userPermissionService: UserPermissionService,
    private tooltipManagerService: TooltipManagerService,
    private transloco: TranslocoService
  ) {}

  registerLockedFeature(): void {
    this.userPermissionService.lockedFeaturesMap.forEach((value, feature) => {
      const { name, price } = value;
      const content = this.transloco.translate("sidebar.upgradeTooltip2", { name, price });
      this.tooltipManagerService.registerLockedTooltipContent(feature, content);
    });
  }

  registerPosMarketplaceUnlock({ reason, canUpgradePlan }: PosMarketplaceUnlockDto): void {
    if (canUpgradePlan && this.userPermissionService.lockedFeaturesMap.has(PermissionTypeDto.PosMarketplace)) {
      return;
    }

    const content = this.transloco.translate(`sidebar.posMarketplaceUnlock.${canUpgradePlan ? "upgrade" : "askProvider"}.${reason}`);
    this.tooltipManagerService.registerLockedTooltipContent(PermissionTypeDto.PosMarketplace, content);
  }

  registerInfoFeature(feature: PermissionTypeDto, content: string): void {
    this.tooltipManagerService.registerInfoTooltipContent(feature, content);
  }
}
